import React, { useEffect } from "react";

//Styles
import styles from "./NewStudentTutorial.module.css";

// MUI Icons
import CloseIcon from "@mui/icons-material/Close";

// Redux
import { useDispatch } from "react-redux";
import { setDemoObj } from "../../store/demo.actions";
import { setPopup } from "../../store/popup.actions";

export default function NewTutorialButton() {
  const etlStudentObj = JSON.parse(localStorage.getItem("etlStudentObj"));
  const dispatch = useDispatch();

  /**
   * @description function to show the interactive demo according to link
   */
  const showInteractiveDemo = () => {
    dispatch(
      setDemoObj({
        demo: true,
        link: "interactive",
      })
    );
  };


  // ftue condition to check if the user is interacting first time or not
  useEffect(() => {
    localStorage.setItem("ftue", JSON.stringify(true));
  }, []);

  return (
    <>
      <div className={styles.popup_overlay}>
        <div className={styles.popup_container}>
          {/* header */}
          <div className={styles.header}>
            {/* Description */}
            <div className={styles.card_container}>
              <span className={styles.title}>
                🎉 Welcome to Your Dashboard,{" "}
                {etlStudentObj?.studentName?.split(" ")?.at(0)} !
              </span>
              <p className={styles.description}>
                Let’s show you how to use this platform to boost your{" "}
                {etlStudentObj?.courses
                  ?.at(0)
                  ?.organisationName?.split(" ")
                  ?.at(0)}{" "}
                rank.
              </p>
            </div>

            {/* Close Icon */}
            <CloseIcon
              className={styles.close_icon}
              onClick={() => dispatch(setPopup(false))}
            />
          </div>

          {/* body */}
          {/* intro video */}
          <div className={styles.videoWrapper}>
            <iframe
              width="855"
              height="481"
              src="https://www.youtube.com/embed/FmblrbYR3iA?si=9OfeOPM5igPWl9Vr&autoplay=1&mute=1&loop=1&playlist=3lhkCUPAFOY"
              title="How To Self-Assess | MY Study Room | MY Exam Room | EaseToLearn"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className={styles.iframe}
            />
          </div>

          {/* buttons */}
          <div className={styles.buttons}>
            <button
              className={styles.primaryBtn}
              onClick={() => {
                dispatch(
                  setDemoObj({
                    demo: true,
                    link: "video",
                  })
                );
                // dispatch(setPopup(false));
              }}
            >
              Watch Full Tour
            </button>
            <button
              className={styles.secondaryBtn}
              onClick={() => dispatch(setPopup(false))}
            >
              Skip for now
            </button>
          </div>

          <div className={styles.footer}>
            <p className={styles.altText}>
              Prefer to explore step-by-step?{"  "}
              <span
                className={styles.demo}
                onClick={() => showInteractiveDemo()}
              >
                Start Interactive Tour
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
